export class Marca {
  id: number;
  name: string;
  code: string;
  fechaBaja?: string;
}
